<template>
    <div>
    <h3 class="is-size-3">Catalogo SCIAN</h3>
        <p> <code>GET {{ host }}/api/scianCatalog/{scianCode?}</code> </p>
        <br>
        <h5 class="is-size-6">El endpoint tiene un parametro opcional:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>scianCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato numerico (Ej. 111110)</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br/>
        <h5 class="is-size-6">El endpoint recibe un token de seguridad en el header:</h5> 
        <pre>
        <code>headers: 
        { 
            "Authentication":"Bearer {TOKEN}",
        }</code>
        </pre>
        <br>
        <h5 class="is-size-6">Respuesta:</h5> 
        <pre>
        <code>[
            {
                "scianCode": "111110",
                "scianDescription": "Cultivo de soya"
            },
            {
                "scianCode": "111121",
                "scianDescription": "Cultivo de cártamo"
            }
            ...
        ]</code>
        </pre>
        <hr />
       
    </div>
</template>

<script>
export default {    
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }    
}
</script>

<style lang="scss" scoped>

</style>